import { ChatbotConfigProvider } from '@pba/ai-assistant-chat-web-widget';
import { type ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentNodeToken } from 'common/services';

const AiAssistantProvider = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const getAuthorizationToken = useCallback(() => getCurrentNodeToken() ?? null, []);

  return (
    <ChatbotConfigProvider
      apiBaseUrl={new URL('/assistant', String(import.meta.env.VITE_APP_NODE_API_URL)).href}
      getToken={getAuthorizationToken}
      hasColoredQuestionBubbles
      hasHiddenAvatars
      texts={{
        errorDescription: t('Something went wrong. Please try again later.'),
        errorTitle: t('Error'),
        introMessage: t(
          "Welcome to BigHeart's AI Knowledge Assistant! I can help you find information from internal documents — including policies, processes, team guides, and more. Ask me anything and I'll do my best to find the right answer for you.",
        ),
        messageDisclaimer: t('Info: Always verify answers — AI responses may not be fully accurate'),
        messagePlaceholder: t('Write a message'),
        openerTitle: t('AI Chat'),
        workspaceTitleSuffix: t('AI Chatbot'),
      }}
      title={t('AI Knowledge Assistant')}
    >
      {children}
    </ChatbotConfigProvider>
  );
};

export default AiAssistantProvider;
